const AUTH_ERROR_PARAM = 'auth_error'
const SAFE_CODE = /^[a-z_]{1,40}$/

/** The `auth_error` code the API redirects back with, or null. Unknown shapes are ignored. */
export const readAuthError = (search: string): string | null => {
  const value = new URLSearchParams(search).get(AUTH_ERROR_PARAM)
  return value && SAFE_CODE.test(value) ? value : null
}

/** The same search string without the auth error, so a reload does not repeat the notice. */
export const withoutAuthError = (search: string): string => {
  const params = new URLSearchParams(search)
  params.delete(AUTH_ERROR_PARAM)
  const rest = params.toString()
  return rest ? `?${rest}` : ''
}

export const AUTH_ERROR_TEXT: Record<string, string> = {
  bad_state: 'the login link expired. Try again.',
  token_exchange: 'GitHub did not accept the login. Try again.',
  user_fetch: 'GitHub did not say who you are. Try again.',
  auth_failed: 'something went wrong on our side. Try again in a moment.',
}

export const authErrorMessage = (code: string): string =>
  `Login failed: ${AUTH_ERROR_TEXT[code] ?? code.replaceAll('_', ' ')}`
